import { Caution } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { usePriorityColor } from '../../../configurable-colors-sounds/use-configured-colors';
import { getPriorityLabelColors } from '../../../configurable-colors-sounds/priority-colors';
import { PriorityLevel } from '../types';

const DEFAULT_CAUTION_LEVEL: PriorityLevel = 4;

export const FrEventPriorityLabel = observer(function FrEventPriorityLabel({
    label,
    level,
    priorityId,
    agencyTypeGlobalAttrId,
}: {
    label: string;
    level: PriorityLevel;
    priorityId: number | undefined;
    agencyTypeGlobalAttrId: number | undefined;
}) {
    const configuredColor = usePriorityColor(priorityId, agencyTypeGlobalAttrId);

    if (!configuredColor.matched) {
        return (
            <Caution priority={level} data-testid="event-priority-label">
                {label}
            </Caution>
        );
    }

    // An explicit "no color" falls back to Arc's neutral caution rather than a transparent badge,
    // since the level colors' text would be unreadable without their fill.
    const { fill, text } = getPriorityLabelColors(configuredColor, { fill: '' });
    return (
        <Caution
            priority={DEFAULT_CAUTION_LEVEL}
            style={fill ? { backgroundColor: fill, color: text } : undefined}
            data-testid="event-priority-label"
        >
            {label}
        </Caution>
    );
});
